<script setup lang="ts">
import CourseListView from 'modules/Course/views/CourseListView/CourseListView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <div class="col fit">
      <CourseListView :filter="{ key: 'is_favorite_all', value: true }" />
    </div>
  </BPage>
</template>
